import {MilestoneIcon} from '@primer/octicons-react'
import {Link, Truncate} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'
import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {MilestoneMetadata$key} from './__generated__/MilestoneMetadata.graphql'
import styles from './MilestoneMetadata.module.css'

const milestoneFragment = graphql`
  fragment MilestoneMetadata on IssueOrPullRequest
  @argumentDefinitions(includeMilestone: {type: "Boolean!", defaultValue: true}) {
    ... on Issue {
      milestone @include(if: $includeMilestone) {
        title
        url
      }
    }

    ... on PullRequest {
      milestone @include(if: $includeMilestone) {
        title
        url
      }
    }
  }
`

type MilestoneMetadataProps = {
  data: MilestoneMetadata$key
}

export const MilestoneMetadata = ({data}: MilestoneMetadataProps) => {
  const {milestone} = useFragment(milestoneFragment, data)

  if (!milestone) return null

  return (
    <>
      ·
      <Link href={milestone.url} muted aria-label={milestone.title} className={styles.milestoneLink}>
        <Octicon icon={MilestoneIcon} size={16} />
        &nbsp;
        <Truncate title={milestone.title} className={styles.milestoneTitleTruncate}>
          {milestone.title}
        </Truncate>
      </Link>
    </>
  )
}

try{ MilestoneMetadata.displayName ||= 'MilestoneMetadata' } catch {}